import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsgsToUserService } from 'libs/shared-lib1/src/lib/msgs-to-user.service';
import { MsgToUser } from 'libs/shared-lib1/src/lib/msgs-to-user/models/MsgToUser.model';
import { catchError, delay, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class App1Service {

  constructor(
    private httpClient: HttpClient,
    private msgsToUserService: MsgsToUserService ) { }

  makeAnApiCall(): Observable<any> {

    const url = "FAIL_ME"; // https://itai.apphb.com/api/angular6/getEmployees";
    let retVal: any;

    return this.httpClient.get<any[]>(url).pipe(

      // delay(5000),

      map((response: any) => {

        // Please note we dont wrap here with of()
        return retVal;

      }),
      catchError((err: any) => {

        const msg ="error in the api call...";
        const color = "red";

        const msgToUser: MsgToUser = new MsgToUser(msg, color);

        this.msgsToUserService.setMsgsToUser(msgToUser);


        //to throw away the WHOLE object
        throw msgToUser;

        //Just a msg
        throw new Error(msg);

        //To get to subscribe
        return of(err);

      })

    );

  }

}


